<template>
    <div class="global">
        <div  v-if="details">
            <div class="video">
                <video :src="dataImgUrl + details.video" controls autoplay></video>
            </div>
            <!-- 小黑板 -->
            <div class="introduce">
                <p class="intr_title">小黑板</p>
                <p class="info">{{details.content}}</p>
            </div>
            <!-- <div class="introduce" v-if="signature.length > 0">
                <p class="title">小黑板</p>
                <p class="content" v-for="(item,index) in signature" :key="index" @click="goSignature(item)">{{item.title}}</p> 
            </div> -->
            <!-- nav -->
            <!-- <div class="nav">
                <p :class="navIndex == 1?'active':''" @click="getNavIndex(1)">简介</p>
                <p :class="navIndex == 2?'active':''" @click="getNavIndex(2)">评论</p>
            </div> -->
            <!-- 简介 -->
            <!-- <div class="introduce" v-if="navIndex == 1">
                <p class="intr_title">全球签介绍</p>
                <p class="info">{{details.content}}</p>
            </div> -->
            <!-- 评论 -->
            <!-- <div class="comment" v-if="navIndex == 2">
                <ul class="comment_list" v-if="commentList.length">
                    <li class="list" v-for="(item,index) in commentList" :key="index">
                        <div class="tx">
                            <img :src="item.logo ? dataImgUrl + item.logo : '//softlinkceshi.oss-cn-beijing.aliyuncs.com/pcimg/we img01.png' ">
                        </div>
                        <div class="info">
                            <div class="name">{{item.name || (item.phone && handlePhone(item.phone)) || '匿名用户'}}</div>
                            <h3>{{item.content}}</h3>
                            <time>{{item.create_time}}</time>
                        </div>
                    </li>
                </ul>
                <div class="question">
                    <textarea placeholder="我要评论～" v-model="userComment"></textarea>
                    <mu-button color="primary" @click="submit" class="submit">提交评论</mu-button>
                </div>
                <div class="no_comment"  v-if="commentList.length == 0">还没有评论</div>
            </div> -->
        </div>
        <div class="nodetails" v-if="!details">
            暂无内容
        </div>
    </div>
</template>

<script>
import api from "@/api/global";
export default {
    data() {
        return {
            dataImgUrl:"http://softlinkceshi.oss-cn-beijing.aliyuncs.com/pcimg/",
            details:{},
            signature:[],
            navIndex:1,
            commentList:[],
            userComment: "", //用户评论
        }
    },
    computed:{
        name(){
            return this.$route.query.name
        }
    },
    methods:{
        getNavIndex(index){
            this.navIndex = index;
        },
        goSignature(item){
            if(item.href){
                window.open(item.href);
            }else{
                sessionStorage.setItem("signature",item.content);
                this.$router.push({
                    path:"/signature",
                })
            }
        },
        //获取数据
        async getDetails(){
            try {
                let re = await api.gs_details({
                    name:this.name
                });
                this.details = re.data.data.details;
                // this.getSignature();
                // this.getCommentList();
            } catch (error) {
                console.error(error);
            }
        },
        // 获取小黑板
         async getSignature(){
            try {
                let re = await api.global_signature_title_list({
                    pid:this.details.id
                });
                this.signature = re.data.data.details;
            } catch (error) {
                console.error(error);
            }
        },
        // 获取评论列表
         async getCommentList(){
            try {
                let re = await api.global_comment_list({
                    id:this.details.id
                });
                // console.log(re,1111)
                this.commentList = re.data.data.list;
            } catch (error) {
                console.error(error);
            }
        },
        // 提交评论
        submit() {
            if (sessionStorage.getItem("userInfo")) {
                if (!this.userComment) {

                    this.$notify("评论内容不能为空！");
                    return;
                }
                this.getCommentApi(this.userComment, "-1");
            } else {
                sessionStorage.setItem("routerPath","/globaldetails");
                sessionStorage.setItem("routerQuery",{
                    name:this.$route.query.name
                });
                this.$router.push({
                    path: "/lodin"
                });
            }
        },
        // 提交品论API
        async getCommentApi(content, id) {
            try {
                let re = await api.add_comment({
                    c_id:this.details.id,
                    content,
                    r_id: id
                });
                this.userComment = "";
                this.$notify({
                    message: "评论成功！",
                    background: "#4285f4"
                });
                this.getCommentList();
            } catch (error) {
                console.error(error);
            }
        },
    },
    activated(){
        this.getDetails();
    }
}
</script>

<style lang="less" scoped>
.global {
    background:#fff;
    padding-bottom:50px;
    .video{
        background:#000;
        video{
            width:100%;
        }
    }
    .nav{
        display: flex;
        border-top:13px solid #F6FAFD;
        p{
            flex:1;
            line-height:50px;
            text-align: center;
            font-size: 30px;
            color:#000000;
            position: relative;
            padding:30px 0 15px;
            &.active{
                color:#2B62D2;
                &::after{
                    content:"";
                    width:40px;
                    height:4px;
                    background:rgba(43,98,210,1);
                    position: absolute;
                    bottom:0;
                    left:50%;
                    transform: translateX(-50%);
                }
            }
        }
    }
    .introduce{
        padding:0px 25px 60px;
        border-top:13px solid #F6FAFD;
        .title{
           text-align: center;
           color:#1A1A1A;
           font-size: 38px;
           padding:60px 0 50px;
           line-height: 38px;
       }
       .intr_title{
            color:rgba(0,0,0,1);
            font-size:30px;
            padding:40px 0 30px;
       }
       .info{
           font-size: 28px;
           color:#4D4D4D;
           line-height:50px;
           margin-bottom:40px;
        }
        .content{
            font-size: 28px;
            color:#4D4D4D;
            line-height:50px;
            margin-bottom:40px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .nodetails{
        text-align: center;
        color:#1A1A1A;
        font-size: 38px;
        padding:60px 0 70px;
        line-height: 38px;
    }
    .comment {
  padding-bottom: 50px;
  .question {
    height: 281px;
    width: 666px;
    margin: 0 auto;
    textarea {
      padding: 18px;
      outline: none;
      resize: none;
      width: 610px;
      height: 99px;
      .mix-1px-all(#F8F9FB);

      border-radius: 9px;
      line-height: 26px;
      margin-top: 32px;
      font-size: 30px;
      box-sizing: content-box;
    }
    .submit {
      width: 136px;
      height: 60px;
      background-color: #2b62d2;
      color: white;
      font-size: 22px;
      float: right;
      margin-right: 17px;
      margin-top: 18px;
      border-radius: 5px;
      line-height: 46px;
      text-align: center;
      border:none;
      outline:none;
    }
  }
  .comment_list {
    padding-bottom: 50px;
    .list {
      width: 684px;
      margin: 0 auto;
      .mix-1px-bottom(#dfdfdf);

      overflow: hidden;
      .tx {
        float: left;
        width: 57px;
        height: 57px;
        border-radius: 50%;
        overflow: hidden;
        margin: 23px 18px 0 6px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .info {
        float: left;
        width: 603px;
        overflow: hidden;
        margin-top: 23px;
        position: relative;
        .name {
          width: 100%;
          height: 57px;
          line-height: 57px;
          font-size: 30px;
          color: #4c4c4c;
        }
        h3 {
          padding-bottom: 1rem;
          font-weight: 300;
          font-size: 26px;
          color: #808080;
          display: block;
          max-height: 9999999px;
        }
        time {
          font-size: 20px;
          color: #808080;
          position: absolute;
          right: 24px;
          bottom: 0.26rem;
        }
      }
    }
  }
  .no_comment {
    font-size: 24px;
    color: #808080;
    margin: 0 auto;
    text-align: center;
    padding-top: 40px;
    margin-top:20px;
    .mix-1px-top(#dedede);

    -webkit-appearance: none;
  }
} 
}
</style>